import React from "react";
import styles from "./Faq.module.css";
import { IconYarn } from "../Icons/Icons";
import { SocialIcons } from "../Icons/Icons";
import { BsInstagram, BsFacebook, BsMailbox } from "react-icons/bs";

function Faq() {
  const data = [
    {
      question: "¿Cómo cuido a mi amigurumi?",
      answer:
        "Para que tu nuevo amigo esté contento te recomiendo lavarlo a mano, con agua fría y que se seque en posición horizontal a la sombra. Y siempre recordá que no debés lavarlo con agua caliente, ni usar blanqueador o jabones abracivos. No lo expongas al sol ni metas en el secarropa 🧸.",
    },
    {
      question: "¿Te puedo hacer un encargo totalmente personalizado?",
      answer:
        "¡Claro que sí! 🥳 Si viste algo que te gustó o tenés una idea de un amigurumi podemos charlar y te digo si puedo realizar el proyecto. El costo de este trabajo no es fijo ya que depende de la complejidad del diseño y el tamaño. El presupuesto se hará antes de iniciar el tejido y se abonará la mitad para poder comenzar a elaborarlo. Recordá que el pedido se hace con bastante anticipación (mínimo dos o tres semanas antes de la fecha en la que necesites tu amigurumi). No dudes en preguntarme si puedo añadir algún detalle especial 🥰.",
    },
    {
      question: "¿Cómo puedo comprar un amigurumi?",
      answer:
        "Si necesitás hacer un pedido personalizado para un evento especial escribime a través de algunas de mis redes o en el formulario que aparece en esta página. Si necesitas inspiración mira mi galería de fotos 📸. También podés seguirme en Instagram o Facebook para conocer en cuáles mercadillos estaré presente este mes para poder ver personalmente mis productos 😎.",
    },
    {
      question: "¿Se aceptan devoluciones?",
      answer:
        "Al momento de comprar no olvides que es un producto hecho 100% a mano por lo tanto, aunque sea un patrón que hice en cantidades, cada amigurumi final es único. En el proceso de creación pueden variar cosas como la fuerza con la que aprieto los puntos. Así que si notás una ligera diferencia con la foto de referencia, es totalmente normal. Por lo tanto NO acepto devoluciones.",
    },
    {
      question: "¿Hacés envíos nacionales o internacionales?",
      answer:
        "NO realizo envíos 😢. Por el momento Paw Paw Needle solo llega a Zaragoza. Si sos zaragozana nos vemos en el próximo mercadillo que anuncie 😎. Pero espero que mis amigurumis lleguen a todas partes de España y del mundo en un futuro no muy lejano.",
    },
  ];

  return (
    <div className={styles.container}>
      <h2>Preguntas frecuentes</h2>
      {data.map(({ question, answer }) => (
        <div className={styles.text}>
          <h3 className={styles.question}>
            <IconYarn
              style={{ height: "4rem", marginRight: "1rem" }}
            ></IconYarn>
            {question}
          </h3>
          <p className={styles.answer}>{answer}</p>
        </div>
      ))}
      <div className={styles.contact}>
        <p>Si tenés alguna otra pregunta no dudes en contactarte conmigo</p>
        <div className={styles.social}>
          <SocialIcons
            href="https://www.instagram.com/pawpawneedle/"
            icon={<BsInstagram></BsInstagram>}
          ></SocialIcons>
          <SocialIcons
            href="https://www.facebook.com/pawpawneedle"
            icon={<BsFacebook></BsFacebook>}
          ></SocialIcons>
          <SocialIcons
            href="mailto:pawpawneedle@gmail.com"
            icon={<BsMailbox></BsMailbox>}
          ></SocialIcons>
        </div>
      </div>
    </div>
  );
}

export { Faq };
